<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chi tiết hồ sơ" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="detailsFile"/>
            </vx-tooltip>
        </div>
        <vs-popup title="Chi tiết hồ sơ" :active.sync="popupShowDetailsFileConsult" v-if="popupShowDetailsFileConsult"
                  id="details_file_consult">
            <div class="vx-card" style="min-height: 170px">
                <div class="vx-row">
                    <div class="vx-col w-1/4 py-6 pl-8 info_file_consult">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Khách hàng:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                    <span
                                        class="text-md font-semibold">{{ infoFileData.loyaltyCustomer.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Trạng thái (KH):</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <vs-chip class="ag-grid-cell-chip"
                                                 :color="chipColorCustomerType(infoFileData.customerType)">
                                        <span
                                            class="text-md font-semibold">{{
                                                checkStatusCustomerType(infoFileData.customerType)
                                            }}</span>
                                        </vs-chip>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.dateAdmission">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Ngày vào viện:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.dateAdmission }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.diagnostic">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Chẩn đoán:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.diagnostic }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.conclude">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Kết luận:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.conclude }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.consultant">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Tư vấn:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.consultant.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.doctor">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Bác sĩ:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.doctor.fullName }}</span>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="vx-col w-full mb-2" v-if="infoFileData.note">-->
<!--                                <div class="vx-row">-->
<!--                                    <div class="vx-col lg:w-1/3 w-full">-->
<!--                                        <span class="text-md font-semibold">Ghi chú:</span>-->
<!--                                    </div>-->
<!--                                    <div class="vx-col lg:w-2/3 w-full">-->
<!--                                        <span class="text-md">{{ infoFileData.note }}</span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="vx-col w-3/4 py-6 pl-8">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <vs-input icon-no-border icon="icon-search" icon-pack="feather"
                                          class="w-full input-rounded-full pr-8"
                                          placeholder="Tìm phiếu theo mã phiếu, mảng dịch vụ hoặc phiếu dịch vụ ..."
                                          v-model="keySearch"
                                          @input="searchMedical"/>
                            </div>
                        </div>
<!--                        <VuePerfectScrollbar ref="scrollDialog"-->
<!--                                             class="scroll-area&#45;&#45;nofications-dropdown size-content vx-row mt-6"-->
<!--                                             :settings="settings"-->
<!--                                             style="max-height: 70vh">-->
<!--                            <div class="vx-col xl:w-1/3 md:w-1/2 w-full mb-6"-->
<!--                                 v-for="(item, index) in detailsMedicalDataSearch"-->
<!--                                 :key="index">-->
<!--                                <div class="medical-bill w-full" @click="showDetailsFile(item)">-->
<!--                                    <div class="vx-row m-4">-->
<!--                                        <div class="vx-col w-full">-->
<!--                                            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="30px"-->
<!--                                                 height="30px" viewBox="0 0 24 24">-->
<!--                                                <path-->
<!--                                                    d="M18,23a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H15a1,1,0,0,0-1,1,2,2,0,0,1-4,0A1,1,0,0,0,9,1H6A3,3,0,0,0,3,4V20a3,3,0,0,0,3,3ZM5,20V11h.882a1,1,0,0,0,0-2H5V4A1,1,0,0,1,6,3H8.126a4,4,0,0,0,7.747,0H18a1,1,0,0,1,1,1V9h-.883a1,1,0,0,0,0,2H19v9a1,1,0,0,1-1,1H6A1,1,0,0,1,5,20ZM7.706,10a1,1,0,0,1,1-1h1.882a1,1,0,1,1,0,2H8.706A1,1,0,0,1,7.706,10Zm4.706,0a1,1,0,0,1,1-1h1.882a1,1,0,0,1,0,2H13.412A1,1,0,0,1,12.412,10ZM11,13h2v2h2v2H13v2H11V17H9V15h2Z"/>-->
<!--                                            </svg>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2" v-if="item.beautyMedicalReportNanoCode">-->
<!--                                            <span>Mã phiếu: </span>-->
<!--                                            <span class="text-md font-semibold">-->
<!--                                            {{ item.beautyMedicalReportNanoCode }}-->
<!--                                        </span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2" v-if="item.beautyGroupService">-->
<!--                                            <span>Mảng dịch vụ: </span>-->
<!--                                            <span class="text-md font-semibold">-->
<!--                                            {{-->
<!--                                                    item.beautyGroupService.code ? (item.beautyGroupService.code + '-' + item.beautyGroupService.name) : item.beautyGroupService.name-->
<!--                                                }}-->
<!--                                        </span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2" v-if="item.beautyService">-->
<!--                                            <span>Nhóm dịch vụ: </span>-->
<!--                                            <span-->
<!--                                                class="text-md font-semibold">{{-->
<!--                                                    item.beautyService.code + '-' + item.beautyService.name-->
<!--                                                }}</span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full"-->
<!--                                             v-for="(itemDetails, ind) in item.beautyMedicalReportDetails" :key="ind"-->
<!--                                             v-if="item.beautyMedicalReportDetails.length > 0 && itemDetails && itemDetails.beautyServicePackage">-->
<!--                                            <span class="text-sm">Dịch vụ: </span>-->
<!--                                            <span class="text-sm font-semibold">-->
<!--                                            {{-->
<!--                                                    itemDetails.beautyServicePackage.code ? (itemDetails.beautyServicePackage.code + '-' + itemDetails.beautyServicePackage.name) : itemDetails.beautyServicePackage.name-->
<!--                                                }}-->
<!--                                        </span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full flex flex-wrap justify-center items-center gap-4">-->
<!--                                            <span class="text-md font-semibold">Trạng thái:</span>-->
<!--                                            <vs-chip class="ag-grid-cell-chip"-->
<!--                                                     :color="item.settingMedicalExaminationStep.medicalExaminationStep.color">-->
<!--                                            <span class="text-md font-semibold">-->
<!--                                                {{ item.settingMedicalExaminationStep.medicalExaminationStep.name }}-->
<!--                                            </span>-->
<!--                                            </vs-chip>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </VuePerfectScrollbar>-->
                        <div class="mt-6">
                            <vs-table stripe :data="detailsMedicalDataSearch" noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <vs-th>
                                        STT
                                    </vs-th>
                                    <vs-th>
                                        Mã phiếu
                                    </vs-th>
                                    <vs-th>
                                        Mảng dịch vụ
                                    </vs-th>
                                    <vs-th>
                                        Nhóm dịch vụ
                                    </vs-th>
                                    <vs-th>
                                        Bác sĩ
                                    </vs-th>
                                    <vs-th>
                                        Y tá
                                    </vs-th>
                                    <vs-th>
                                        Lý do
                                    </vs-th>
                                    <vs-th>
                                        Kết luận
                                    </vs-th>
                                    <vs-th>
                                        Trạng thái
                                    </vs-th>
                                    <vs-th>
                                        Hành động
                                    </vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                        <vs-td>
                                            {{indextr + 1}}
                                        </vs-td>
                                        <vs-td>
                                            {{tr.beautyMedicalReportNanoCode ? tr.beautyMedicalReportNanoCode : null}}
                                        </vs-td>
                                        <vs-td>
                                            {{tr.beautyGroupService ? (tr.beautyGroupService.code ? (tr.beautyGroupService.code + ' - ' + tr.beautyGroupService.name) : tr.beautyGroupService.name) : null}}
                                        </vs-td>
                                        <vs-td>
                                            <div v-for="(medical, index) in tr.beautyMedicalReportDetails"
                                                 :key="index"
                                                 v-if="tr.beautyMedicalReportDetails.length > 0">
                                                <vx-tooltip class="position-icon" color="primary" :text="medical.beautyService.code + ' - ' + medical.beautyService.name" position="top" v-if="medical.beautyService">
                                                    <span class="text-md font-semibold text-primary whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 150px !important;">
                                                    {{ medical.beautyService.code + ' - ' + medical.beautyService.name }}
                                                    </span>
                                                </vx-tooltip>
                                            </div>
                                        </vs-td>
                                        <vs-td>
                                            {{tr.doctor}}
                                        </vs-td>
                                        <vs-td>
                                            {{tr.nurse}}
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" color="primary" :text="tr.reason" position="top" v-if="tr.reason">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 150px !important;">
                                                    {{tr.reason}}
                                                </span>
                                            </vx-tooltip>
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" color="primary" :text="tr.conclude" position="top" v-if="tr.conclude">
                                                    <span class="whitespace-no-wrap overflow-hidden text-ellipsis block" style="width: 150px !important;">
                                                    {{tr.conclude}}
                                                </span>
                                            </vx-tooltip>
                                        </vs-td>
                                        <vs-td>
                                            <vs-chip class="ag-grid-cell-chip-consult"
                                                     :color="tr.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                tr.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                                            </vs-chip>
                                        </vs-td>
                                        <vs-td>
                                            <vx-tooltip class="position-icon" text="Chi tiết" position="top">
                                                <feather-icon icon="EyeIcon" class="action-success mt-3 text-success"
                                                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                              @click="showDetailsFile(tr)"/>
                                            </vx-tooltip>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo details-file" title="Lorem ipsum dolor sit amet" id="details_file_popup"
                      :active.sync="isShowDetailsFile">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Chi tiết phiếu khám</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeDetailsFile"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row mt-6" v-if="medicalInfo && medicalInfo.beautyMedicalReportNanoCode">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Mã phiếu:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span
                        class="text-md font-semibold text-primary">{{
                            medicalInfo.beautyMedicalReportNanoCode
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.beautyGroupService">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Mảng dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span
                        class="text-md font-semibold text-primary">{{
                            medicalInfo.beautyGroupService.code ? (medicalInfo.beautyGroupService.code + '-' + medicalInfo.beautyGroupService.name) : medicalInfo.beautyGroupService.name
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.beautyService">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span
                        class="text-md font-semibold text-primary">{{
                            medicalInfo.beautyService.code + '-' + medicalInfo.beautyService.name
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.beautyMedicalReportDetails.length > 0">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <div class="vx-row" v-for="(medical, index) in medicalInfo.beautyMedicalReportDetails"
                             :key="index"
                             v-if="medical && medical.beautyService">
                            <div class="vx-col w-full">
                            <span class="text-md font-semibold text-primary">
                                {{ medical.beautyService.code + '-' + medical.beautyService.name }}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.hospitalAdmissionDateStr">-->
<!--                    <div class="vx-col lg:w-1/3 w-full">-->
<!--                        <span class="text-md font-semibold">Ngày vào viện:</span>-->
<!--                    </div>-->
<!--                    <div class="vx-col lg:w-2/3 w-full">-->
<!--                    <span class="text-md">-->
<!--                        {{ medicalInfo.hospitalAdmissionDateStr }}-->
<!--                    </span>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.doctor">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Bác sĩ:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalInfo.doctor.fullName }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.nurse">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Y tá:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalInfo.nurse.fullName }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.reason">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Lý do:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalInfo.reason }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.conclude">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Kết luận:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                    <span class="text-md">
                        {{ medicalInfo.conclude }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="medicalInfo && medicalInfo.settingMedicalExaminationStep">
                    <div class="vx-col lg:w-1/3 w-full">
                        <span class="text-md font-semibold">Trạng thái:</span>
                    </div>
                    <div class="vx-col lg:w-2/3 w-full">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="medicalInfo.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                medicalInfo.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                        </vs-chip>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    name: "CellRendererActionsConsulting",
    components: {
        VuePerfectScrollbar,
    },
    data() {
        return {
            //Details files
            popupShowDetailsFileConsult: false,
            keySearch: null,
            pageNumber: 0,
            pageSize: 20,
            currentPage: 1,
            totalPages: 1,
            totalElements: 0,
            settings: {
                wheelSpeed: 0.3,
                suppressScrollX: true,
            },
            isShowDetailsFile: false,
            infoFileData: [],
            detailsMedicalData: [],
            detailsMedicalDataSearch: [],
            medicalInfo: null,

            //Table
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
        }
    },

    computed: {
        chipColorCustomerType() {
            return value => {
                if (value === 1) {
                    return "success";
                } else if (value === 2) {
                    return 'warning'
                } else if (value === 3) {
                    return 'success'
                } else if (value === 4) {
                    return 'danger'
                } else if (value === 5) {
                    return 'warning'
                } else if (value === 6) {
                    return 'danger'
                } else if (value === 7) {
                    return 'warning'
                }
            }
        },
        checkStatusCustomerType() {
            return value => {
                if (value === 1) {
                    return "Khách hàng cũ tới tái khám";
                } else if (value === 2) {
                    return "Khách hàng cũ sử dụng dịch vụ"
                } else if (value === 3) {
                    return "Khách hàng cũ tới tư vấn dịch vụ"
                } else if (value === 4) {
                    return "Khách hàng mới đến tư vấn"
                } else if (value === 5) {
                    return "Khách hàng tới mua thuốc mỹ phẩm"
                } else if (value === 6) {
                    return "Khách hàng trả lại thuốc"
                } else if (value === 7) {
                    return "Khách hàng tới hoàn phí"
                }
            }
        },
    },

    methods: {
        detailsFile() {
            this.infoFileData = this.params.data;
            this.infoFileData.dateAdmission = this.infoFileData.dateAdmission.includes('/') ? this.infoFileData.dateAdmission : moment(this.infoFileData.dateAdmission).format('DD/MM/YYYY');
            this.detailsMedicalData = this.infoFileData.beautyMedicalReports.map(el => {
                el.hospitalAdmissionDateStr = el.hospitalAdmissionDate ? moment(el.hospitalAdmissionDate).format('DD/MM/YYYY') : null;
                return el;
            });
            this.detailsMedicalDataSearch = this.detailsMedicalData;
            this.popupShowDetailsFileConsult = true;
        },

        showDetailsFile(data) {
            this.medicalInfo = null;
            this.medicalInfo = data;
            this.isShowDetailsFile = true;
        },

        closeDetailsFile() {
            this.isShowDetailsFile = false;
            setTimeout(() => {
                this.medicalInfo = null;
            }, 500)
        },

        searchMedical(event) {
            let str = event.toLowerCase();
            this.detailsMedicalDataSearch = this.detailsMedicalData.filter(el => (el.beautyService ? (el.beautyService.name.toLowerCase().includes(str) || el.beautyService.code.toLowerCase().includes(str) || el.beautyMedicalReportNanoCode.toLowerCase().includes(str)) : el.beautyMedicalReportNanoCode.toLowerCase().includes(str)) || (el.beautyGroupService ? el.beautyGroupService.name.toLowerCase().includes(str) : false));
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style lang="scss">
#details_file_consult {
    min-height: 255px;
    z-index: 54000 !important;

    .medical-bill {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        border: 1px solid #dbdade;
        border-radius: 0.375rem;
        min-height: 150px;
        cursor: pointer;
    }

    .medical-bill:hover {
        color: rgba(var(--vs-primary), 1);
        border: 1px solid rgba(var(--vs-primary), 1);

        svg {
            fill: rgba(var(--vs-primary), 1);
        }
    }

    .info_file_consult {
        border-right: 1px solid #dbdade;
        //display: flex;
        //justify-content: center;
    }

    .vs-popup {
        width: 100% !important;
    }
}

#details_file_popup {
    z-index: 55000 !important;

    .vs-popup--header {
        display: none;
    }
}
.ag-grid-cell-chip-consult {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .2);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .2);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .2);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }
}
</style>
